export interface VirtualPageView {
	Lobby: boolean;
	LobbyName: string;
	VirtualUrl: string;
	VirtualTitle: string;
	SubArea?: string;
	event?: string;
}

export const DEFAULT_EXPERIMENT_VARIANT = "0";
